import { foldazApi } from 'api'
import isBlank from 'is-blank'
import {
  SET_THEME,
  UPDATE_THEME_PROPERTY,
  CLIENT_DEFAULT_THEME,
} from './types'

export const state = {
  data: CLIENT_DEFAULT_THEME,
}

export const mutations = {
  [SET_THEME] (state, value) {
    state.data = isBlank(value) ? CLIENT_DEFAULT_THEME : JSON.parse(value)
  },
  [UPDATE_THEME_PROPERTY] (state, {key, value}) {
    state.data = { ...state.data, [key]: value }
  }
}

export const actions = {
  setTheme ({ commit }, value) {
    commit(SET_THEME, value)
  },

  updateThemeProperty ({ commit }, payload) {
    commit(UPDATE_THEME_PROPERTY, payload)
  },

  apply ({ state }) {
    const theme = state.data

    for (const key of Object.keys(theme)) {
      window.document.documentElement.style.setProperty(`--${key}`, theme[key]);
    }
  },

  load ({ commit, dispatch }, clientId) {
    return foldazApi.get(`/clients/${clientId}`)
      .then((response) => {
        commit(SET_THEME, response.data.client.theme)
        dispatch('apply')
      })
  },

  save ({ state }, clientId) {
    return foldazApi.put(`/clients/${clientId}`, {
      client: {
        theme: JSON.stringify(state.data)
      }
    })
  },

  reset ({ commit, dispatch }) {
    commit(SET_THEME, '')
    dispatch('apply')
  }
}

export const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/clients/clientTheme.js